<div *ngFor="let item of entity?.summed; let i = index" class="m-b">
  <div [attr.aria-expanded]="item?.isCollapsed">
    <div class="well well-lg card card-block card-header" [ngClass]="{'active': item?.isCollapsed}">
      <div class="row title-well">
        <div class="switch">
          <div class="onoffswitch">
            <input type="checkbox" (change)="selectAll(!item?.check, item)" [checked]="item?.check" class="onoffswitch-checkbox" id="{{item?.name}}" [disabled]="entity?.readonly">
            <label class="onoffswitch-label" for="{{item?.name}}">
              <span class="onoffswitch-inner switchSimNao"></span>
              <span class="onoffswitch-switch"></span>
            </label>
          </div>
        </div>
        <div class="name_indicador" (click)="item.isCollapsed = !item?.isCollapsed">
          {{item?.name}}
        </div>
      </div>
    </div>
  </div>

  <div class="system-table table-container" [collapse]="!item?.isCollapsed" [isAnimated]="true">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Código</th>
            <th>Indicador</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let value of item?.value; let valueIndex = index">
            <tr>
              <td class="title">
                <div class="switch">
                  <div class="onoffswitch">
                    <input type="checkbox" (change)="value.check = !value?.check; changeselectAll()" [checked]="value?.check" class="onoffswitch-checkbox" id="{{ value?.id }}" [disabled]="entity?.readonly">
                    <label class="onoffswitch-label" for="{{ value?.id }}">
                      <span class="onoffswitch-inner switchSimNao"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
              </td>
              <td>{{ value?.id }}</td>
              <td>{{ value?.title }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="text-center" *ngIf="entity?.summed?.length == 0">
  <h3>Nenhum Indicador Somando Vinculado ao {{entity?.title}}</h3>
</div>

<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
    <button class="btn btn-primary" type="button" (click)="salvar()" *ngIf="!this.entity?.readonly">Salvar</button>
  </div>
</div>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>